import { handleAuthCallback } from '~auth';

export const authRoute = async () => {
  document.title = 'Autenticazione | Giotto';
  await handleAuthCallback();
};
